export enum InvoiceTypeEnum {
  MainInvoice = 1,
  PaymentCoupon = 2,
  Receipt = 3,
  OneDollarInvoice = 4,
  TermsAndConditions = 5,
}
